import * as yup from 'yup'; // https://github.com/jquense/yup#string
import json from '@onehat/ui/src/Functions/jsonValidator';

const Contents = {
	
	name: 'Contents',
	
	model: {

		idProperty: 'contents__id',
		displayProperty: 'contents__sort_order',
		sortProperty: 'contents__sort_order',
		
		sorters: null,

		validator: yup.object({
			contents__content_type_id: yup.number().integer().required(),
			contents__json: json(true).nullable(),
			contents__enabled: yup.boolean().required()
		}),
		
		properties: [
			{ name: 'contents__id', mapping: 'id', title: 'Id', type: 'int', isFilteringDisabled: true, fieldGroup: 'General', },
			{ name: 'contents__screen_id', mapping: 'screen_id', title: 'Screen', type: 'int', isFk: true, fkIdField: 'screens__id', fkDisplayField: 'screens__title', filterType: {"type":"ScreensCombo","loadAfterRender":!1}, isEditingDisabled: true, fieldGroup: 'General', },
			{ name: 'contents__content_type_id', mapping: 'content_type_id', title: 'Content Type', type: 'int', isFk: true, fkIdField: 'content_types__id', fkDisplayField: 'content_types__class_name', filterType: {"type":"ContentTypesCombo","loadAfterRender":!1}, editorType: {"type":"ContentTypesCombo","loadAfterRender":!1}, fieldGroup: 'General', },
			{ name: 'contents__json', mapping: 'json', title: 'Json', type: 'json', isFilteringDisabled: true, viewerType: {"type":"Json"}, editorType: {"type":"Json"}, fieldGroup: 'General', },
			{ name: 'contents__sort_order', mapping: 'sort_order', title: 'Sort Order', type: 'int', filterType: {"type":"NumberRange"}, isEditingDisabled: true, fieldGroup: 'General', defaultValue: 100000, },
			{ name: 'contents__enabled', mapping: 'enabled', title: 'Enabled', type: 'bool', filterType: {"type":"Toggle"}, editorType: {"type":"Toggle"}, fieldGroup: 'General', defaultValue: 1, },
			{ name: 'contents__path', mapping: 'path', title: 'Path', isVirtual: true, isFilteringDisabled: true, isEditingDisabled: true, fieldGroup: 'General', },
			{ name: 'content_types__id', mapping: 'content_type.id', title: 'Id', type: 'int', isForeignModel: true, isEditingDisabled: true, isFilteringDisabled: true, },
			{ name: 'content_types__name', mapping: 'content_type.name', title: 'Name', isForeignModel: true, isEditingDisabled: true, isFilteringDisabled: true, },
			{ name: 'content_types__class_name', mapping: 'content_type.class_name', title: 'Class Name', isForeignModel: true, isEditingDisabled: true, isFilteringDisabled: true, },
			{ name: 'screens__id', mapping: 'screen.id', title: 'Id', type: 'int', isForeignModel: true, isEditingDisabled: true, isFilteringDisabled: true, },
			{ name: 'screens__title', mapping: 'screen.title', title: 'Title', isForeignModel: true, isEditingDisabled: true, isFilteringDisabled: true, },
			{ name: 'screens__screen_type_id', mapping: 'screen.screen_type_id', title: 'Screen Type', type: 'int', isForeignModel: true, isEditingDisabled: true, isFilteringDisabled: true, },
			{ name: 'screens__sort_order', mapping: 'screen.sort_order', title: 'Sort Order', type: 'int', isForeignModel: true, isEditingDisabled: true, isFilteringDisabled: true, },
			{ name: 'screens__track_engagement', mapping: 'screen.track_engagement', title: 'Track Engagement', type: 'bool', isForeignModel: true, isEditingDisabled: true, isFilteringDisabled: true, },
			{ name: 'screens__json', mapping: 'screen.json', title: 'Json', type: 'json', isForeignModel: true, isEditingDisabled: true, isFilteringDisabled: true, },
			{ name: 'screens__parent_id', mapping: 'screen.parent_id', title: 'Parent', type: 'int', isForeignModel: true, isEditingDisabled: true, isFilteringDisabled: true, },
			{ name: 'screens__path', mapping: 'screen.path', title: 'Path', isForeignModel: true, isEditingDisabled: true, isFilteringDisabled: true, }
		],

		associations: {
			hasMany: [
				'Ratings'
			],
			belongsTo: [
				'ContentTypes',
				'Screens'
			],

		},

		ancillaryFilters: [],

		defaultFilters: [
			// 'contents__screen_id',
			// 'contents__content_type_id',
			// 'contents__sort_order',
			// 'contents__enabled'
		],

	},

	entity: {
		methods: {

			getRatings: function() {
				const Ratings = this.getAssociatedRepository('Ratings');
				return Ratings.getBy((entity) => {
					return entity.ratings__content_id === this.contents__id;
				});
			},

			getContentType: async function() {
				const ContentTypes = this.getAssociatedRepository('ContentTypes');
				let entity = ContentTypes.getById(this.contents__content_type_id);
				if (!entity) {
					entity = await ContentTypes.getSingleEntityFromServer(this.contents__content_type_id);
				}
				return entity;
			},

			getScreen: async function() {
				const Screens = this.getAssociatedRepository('Screens');
				let entity = Screens.getById(this.contents__screen_id);
				if (!entity) {
					entity = await Screens.getSingleEntityFromServer(this.contents__screen_id);
				}
				return entity;
			},

		},
	},


	repository: {
	    "type": "onebuild",
	    "isRemotePhantomMode": false,
	    "isAutoLoad": false,
	    // "isPaginated": false, // MOD
	    // "isDynamic": true // MOD - used on mobile app only
	},

};

export default Contents;
